import React, { useState, useEffect } from "react";
import { Box, Divider, Grid, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";

function Footer() {
  const location = useLocation();
  const [nombreSistema, setNombreSistema] = useState(() => localStorage.getItem('nombre_sistema') || 'Sistema de Gestión');

  useEffect(() => {
    setNombreSistema(localStorage.getItem('nombre_sistema') || 'Sistema de Gestión');
  }, [location.pathname]);

  return (
    <Box
      sx={{
        bottom: '0px',
        marginTop: '5%'
      }}
    >
    <Divider />
    <Grid container direction="column" alignItems="center">
      <Grid item xs={12}>
        <Typography color="textSecondary" style={{padding: '16px'}}>
          {new Date().getFullYear()} - {nombreSistema} | v2.0
        </Typography>
      </Grid>
      </Grid>
    </Box>
  );
};

export default Footer;